import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-utenti-dettaglio',
  templateUrl: './utenti-dettaglio.component.html',
  styleUrls: ['./utenti-dettaglio.component.css']
})
export class UtentiDettaglioComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  objdettaglio: any;
  public isEdit: number = 0;

  lstAtenei: any;
  lstDipartimenti: any;
  lstRuolo: any;
  lstReferente: any;
  lstSettoreScientifico: any;

  constructor(public dialogRef: MatDialogRef<UtentiDettaglioComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettaglio Utente'
  }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
      idUtentiProfilo: [null],
      Cognome: [null],
      Nome: [null],
      Email: [null, [Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}')]],
      Password: [null, [
        Validators.minLength(8),
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!.@$%^&*-]).{8,}$')
      ]],
      idAteneo: [null],
      idDipartimento: [""],
      Dipartimento: [null],
      NewsLetterStrutturato: [null],
      NewsLetterNonStrutturato: [null],
      NewsLetterGenerica: [null],
      idRuolo: [null],
      idReferenteTipologia: -1,
      idSettoreScientifico: [null],
      Telefono: [null],
      CodiceFiscale: ['', [Validators.pattern('^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$')]],
      isVerificato: [null]
      })

    if (this.data.iValore >= 0) {
      // console.log('ivalore modale', this.data.iValore)
      this.getDettaglio(this.data.iValore)
      this.isEdit = 0;
    } else {
      this.titolo = this.titolo + ' - Inserimento ';
      this.isEdit = 1;
    }


    this.getListaAtenei();
    this.getListaDipartimenti('');
    this.getListaRuolo();
    this.getListaReferente();
    this.getListaSettoreScientifico();
  }


  getDettaglio(iValore: number) {
    this.srvUtilita.getObj('Utenti/GetUtentiDettaglio?idUtentiProfilo=' + iValore).subscribe((res: any) => {
      this.objdettaglio = res
      //console.log(res, 'res')
      this.frmInserimento.patchValue(this.objdettaglio)
 
    //  this.titolo = this.titolo + ": " + this.objdettaglio.Cognome + " " + this.objdettaglio.Nome

      this.getListaAtenei();
      this.getListaDipartimenti(this.objdettaglio.idAteneo);
      this.getListaRuolo();
      this.getListaReferente();
      this.getListaSettoreScientifico();
    })
  }

  getListaAtenei() {
    this.srvUtilita.getLista('Utenti/GetAteneiLista').subscribe((res: any) => {
      this.lstAtenei = res
      //   console.log('res', res)
    })
  }

  getListaDipartimenti(idAteneo: any) {
    this.srvUtilita.getLista('Utenti/GetDipartimentiLista?idAteneo=' + idAteneo).subscribe((res: any) => {
      this.lstDipartimenti = res
      //  console.log('this.lstElenco', res)
    }, (err: any) => {
    })
  }

 

 /* getListaRuolo() {
    this.srvUtilita.getLista('Utenti/GetUtentiProfiloRuoloLista').subscribe((res: any) => {
      this.lstRuolo = res
      //console.log("this.lstRuolo:", this.lstRuolo);
    }, (err: any) => {
    })
  }*/

  getListaRuolo() {
      this.srvUtilita.getLista('Utenti/GetRuoliStrutturatoLista').subscribe((res: any) => {
        this.lstRuolo = res
        //console.log("this.lstRuolo:", this.lstRuolo);
      }, (err: any) => {
      })
    }

  getListaReferente() {
    this.srvUtilita.getLista('Utenti/GetUtentiProfiloReferenteTipologiaLista').subscribe((res: any) => {
      this.lstReferente = res
      //console.log("this.lstReferente:", this.lstReferente);
    }, (err: any) => {
    })
  }

  getListaSettoreScientifico() {
    this.srvUtilita.getLista('Utenti/GetSettoreScientificoLista').subscribe((res: any) => {
      this.lstSettoreScientifico = res
      //console.log("this.lstSettoreScientifico:", this.lstSettoreScientifico);
    }, (err: any) => {
    })
  }

  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    if (objInserimento.NewsLetterStrutturato == true) {
      objInserimento.NewsLetterStrutturato = 1
    } else {
      objInserimento.NewsLetterStrutturato = 0
    }

    if (objInserimento.NewsLetterNonStrutturato == true) {
      objInserimento.NewsLetterNonStrutturato = 1
    } else { objInserimento.NewsLetterNonStrutturato = 0 }

    if (objInserimento.NewsLetterGenerica == true) {
      objInserimento.NewsLetterGenerica = 1
    } else { objInserimento.NewsLetterGenerica = 0 }

    if (objInserimento.isVerificato == true) {
      objInserimento.isVerificato = 1
    } else {
      objInserimento.isVerificato = 0
    }


    //console.log('form', objInserimento)

    const obj = {
      idUtentiProfilo: this.data.iValore,
      Cognome: objInserimento.Cognome,
      Nome: objInserimento.Nome,
      Email: objInserimento.Email,
      Password: objInserimento.Password,
      idAteneo: objInserimento.idAteneo,
      idDipartimento: objInserimento.idDipartimento,
      NewsLetterStrutturato: objInserimento.NewsLetterStrutturato,
      NewsLetterNonStrutturato: objInserimento.NewsLetterNonStrutturato,
      NewsLetterGenerica: objInserimento.NewsLetterGenerica,
      idRuolo: objInserimento.idRuolo,
      idReferenteTipologia: objInserimento.idReferenteTipologia,
      idSettoreScientifico: objInserimento.idSettoreScientifico,
      Telefono: objInserimento.Telefono,
      CodiceFiscale: objInserimento.CodiceFiscale,
      isVerificato: objInserimento.isVerificato
    }

    if (objInserimento.idUtentiProfilo > 0) { //modifica
      this.srvUtilita.postObj('Utenti/PostUtenti', obj).subscribe((res: any) => {
      //  console.log('res', res)
        this.showMessage('I dati sono stati modificati in modo corretto.', 'OK')
        this.dialogRef.close()
      }, (err: any) => {
          this.showMessage('Errore: i dati non sono stati modificati in modo corretto', 'OK')
      })
    } else { //nuovo
      this.srvUtilita.getObj('Utenti/VerificaEmailCodiceFiscale?sEmail=' + objInserimento.Email + '&sCodiceFiscale=' + objInserimento.CodiceFiscale).subscribe((res: any) => {
        if (res == 1) {
      this.srvUtilita.postObj('Utenti/PostUtenti', obj).subscribe((res: any) => {
      //  console.log('res', res)
        this.showMessage('I dati sono stati inseriti in modo corretto.', 'OK')
      }, (err: any) => {
        this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
       // console.log(err.error.Message, 'ERRORE');
      })
        }
        if (res == 2) {
          this.showMessage('Errore: Codice FISCALE e EMAIL già presente ', 'OK')
        }
        if (res == 3) {
          this.showMessage('Errore: EMAIL già presente. ', 'OK')
        }
        if (res == 4) {
          this.showMessage('Errore: Codice FISCALE già presente. ', 'OK')
        }
      }, (err: any) => {
        this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
        //console.log(err.error.Message, 'ERRORE');
      })

    }
   

   }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

}
